import React, { useEffect, useState } from "react";
import "./style.css";
import ACS from "assets/image/ACS.png";
import shape_portal1 from "assets/image/shape_portal1.svg";
import shape_portal2 from "assets/image/shape_portal2.svg";
import Disc from "assets/image/disc_login.png";
import CFIT from "assets/image/CFIT.svg";
import TOELF from "assets/image/TOELF.png";
import PAPI from "assets/image/PAPI.png";
import { Button } from "@material-ui/core";
import {
  MuiThemeProvider,
  createMuiTheme,
  withStyles,
} from "@material-ui/core/styles";
import { useDispatch, useSelector } from "react-redux";
import { getListTest, getLisByUserId } from "redux/actions/general";
import { getDetailUser } from "redux/actions/peserta";
import Loader from "components/Loading";
import {
  resetQuestion,
  resetPapi,
  resetCfit,
  resetToefl,
  resetAssestmentReducer,
} from "redux/actions/assestment";
import FullscreenEnforcer from "components/FullscreenEnforcer";
import { useHistory } from "react-router-dom";
import Cookie from "universal-cookie";
import Portal_biofarma from "assets/image/biofarma_logo.png";

const cookie = new Cookie();
const themeButton = createMuiTheme({
  palette: {
    primary: {
      main: "#00ABBD",
      contrastText: "#FFFFFF",
    },
  },
});

export default function Index(props) {
  const dispatch = useDispatch();
  const general = useSelector((state) => state.general);
  const history = useHistory();

  useEffect(() => {
    // dispatch(resetAssestmentReducer())
    getUsert();
    dispatch(getLisByUserId(`/${props.profile.id}`));
    dispatch(getListTest());
  }, []);

  const TIMER_CONFIG = {
    "Situational Judgement Test BOD-2 Case A": {
      cookieElapsed: "elapsed_time_bod2",
      cookieStart: "start_time_bod2",
    },
    "Situational Judgement Test BOD-2 Case B": {
      cookieElapsed: "elapsed_time_bod2_gap",
      cookieStart: "start_time_bod2_gap",
    },
    "Situational Judgement Test BOD-3 Case A": {
      cookieElapsed: "elapsed_time_bod3",
      cookieStart: "start_time_bod3",
    },
    "Situational Judgement Test BOD-3 Case B": {
      cookieElapsed: "elapsed_time_bod3_gap",
      cookieStart: "start_time_bod3_gap",
    },
  };

  const handleStartTest = (title) => {
    const link = renderLink(title);
    const config = TIMER_CONFIG[title];

    if (config && !cookie.get(config.cookieElapsed)) {
      cookie.set(config.cookieElapsed, 0, { path: "/" });
      cookie.set(config.cookieStart, Date.now(), { path: "/" });
    }

    history.push(link);
  };

  const getUsert = async () => {
    let res = await dispatch(getDetailUser(`/${props.profile.id}`));
    if (res) {
      if (res.data.completed) {
        window.location.assign(`/done/${res.data.projectName}`);
      }
    }
  };

  const getTestDuration = (testName) => {
    switch (testName) {
      case "Situational Judgement Test BOD-2 Case A":
        return "30 Menit";
      case "Situational Judgement Test BOD-2 Case B":
        return "20 Menit";
      case "Situational Judgement Test BOD-3 Case A":
        return "25 Menit";
      case "Situational Judgement Test BOD-3 Case B":
        return "25 Menit";
      default:
        return null;
    }
  };

  const renderImg = (title) => {
    switch (title) {
      case "Work Personality Trait":
        return Disc;
      case "Work Personality Trait (DISC)":
        return Disc;
      case "Work Preference Test":
        return PAPI;
      case "Work Preference Test (PAPI)":
        return PAPI;
      case "English Ability Test":
        return TOELF;
      case "English Ability Test (TOEFL) ":
        return TOELF;
      case "Intellectual Ability Test":
        return CFIT;
      case "Intellectual Ability Test (CFIT)":
        return CFIT;
      case "Situational Judgement Test BOD-2 Case A":
        return Disc;
      case "Situational Judgement Test BOD-2 Case B":
        return PAPI;
      case "Situational Judgement Test BOD-3 Case A":
        return Disc;
      case "Situational Judgement Test BOD-3 Case B":
        return PAPI;

      default:
        break;
    }
  };

  const renderLink = (title) => {
    switch (title) {
      case "Work Personality Trait":
        return "/disc/welcome";
      case "Work Preference Test":
        return "/papi/assestment";
      case "English Ability Test":
        return "/toefl/assestment";
      case "Intellectual Ability Test":
        return "/cfit/assestment";
      case "Situational Judgement Test BOD-2 Case A":
        return "/bod2/welcome";
      case "Situational Judgement Test BOD-2 Case B":
        return "/bod2-gap/welcome";
      case "Situational Judgement Test BOD-3 Case A":
        return "/bod3/welcome";
      case "Situational Judgement Test BOD-3 Case B":
        return "/bod3-gap/welcome";
      default:
        break;
    }
  };

  const handleDisable = (index) => {
    if (general.list_test_by_userid.length > 0) {
      if (index == 0 && general.list_test_by_userid[0].completed == false) {
        return false;
      } else if (index !== 0) {
        if (general.list_test_by_userid[index].completed) {
          return true;
        } else {
          if (general.list_test_by_userid[index - 1].completed) {
            return false;
          } else {
            return true;
          }
        }
      } else {
        return true;
      }
    }
  };

  const renderGap = () => {
    if (general.list_test_by_userid.length > 3) {
      return 20;
    } else {
      return 60;
    }
  };

  // console.log('assestment.list_test_by_userid', general.list_test_by_userid)
  return (
    // <FullscreenEnforcer>
    <div style={{ backgroundColor: "#fcfcfc" }}>
      <Loader />
      <img src={shape_portal1} className="portal-shape shape-top" />
      <img src={shape_portal2} className="portal-shape shape-bottom" />
      <div className="portal-header">
        <img src={Portal_biofarma} className="portal-logo" />
      </div>
      <div className="portal-body">
        <div style={{ position: "absolute" }}>
          <h2 className="portal-body-h2">Situational Judgement Test</h2>
          {/* <p className="portal-body-p">
            Deliver assessment report as valuable information for the
            participants
            <br /> and provide development plan for each participant.
          </p> */}
        </div>
        <br />
        <div className="portal-card-wrapper">
          {general.list_test_by_userid.map((data, i) => (
            <div
              className="portal-card"
              key={i}
              style={{ marginRight: renderGap(), marginBottom: 10 }}
            >
              <img src={renderImg(data.text)} />
              <div className="portal-card-content">
                <h1>{data.text}</h1>
                {getTestDuration(data.text) && (
                  <p
                    style={{
                      color: "#333",
                      fontWeight: "bold",
                      fontSize: 14,
                      marginTop: 8,
                      marginBottom: 0,
                    }}
                  >
                    Waktu Pengerjaan: {getTestDuration(data.text)}
                  </p>
                )}
              </div>
              <div className="portal-card-footer">
                <MuiThemeProvider theme={themeButton}>
                  <Button
                    disabled={handleDisable(i)}
                    onClick={() => handleStartTest(data.text)}
                    className="btn-remove-capital btn-rounded"
                    style={{ width: "100%" }}
                    size="medium"
                    color="primary"
                    variant="contained"
                  >
                    Ikuti Test
                  </Button>
                </MuiThemeProvider>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
    // </FullscreenEnforcer>
  );
}
